import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Package, ShoppingBag, Users, Mail } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ products: 0, orders: 0, customers: 0, newsletter: 0, revenue: 0 });
    const [recentOrders, setRecentOrders] = useState([]);

    useEffect(() => {
        Promise.all([
            api.get("/admin/products"),
            api.get("/admin/orders"),
            api.get("/admin/customers"),
            api.get("/admin/newsletter"),
        ]).then(([p, o, c, n]) => {
            const revenue = o.data.filter(x => x.payment_status === "paid").reduce((s, x) => s + x.total, 0);
            setStats({
                products: p.data.length,
                orders: o.data.length,
                customers: c.data.length,
                newsletter: n.data.length,
                revenue,
            });
            setRecentOrders(o.data.slice(0, 8));
        }).catch(() => {});
    }, []);

    const cards = [
        { label: "Prodotti", value: stats.products, icon: Package },
        { label: "Ordini", value: stats.orders, icon: ShoppingBag },
        { label: "Clienti", value: stats.customers, icon: Users },
        { label: "Newsletter", value: stats.newsletter, icon: Mail },
    ];

    return (
        <div data-testid="admin-dashboard">
            <div className="overline mb-3">Panoramica</div>
            <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)] mb-10">Dashboard</h1>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
                {cards.map(c => {
                    const Icon = c.icon;
                    return (
                        <div key={c.label} className="panel p-6" data-testid={`stat-${c.label.toLowerCase()}`}>
                            <Icon size={18} className="text-[color:var(--ms-sage-dark)] mb-4" />
                            <div className="text-3xl font-display text-[color:var(--ms-charcoal)]">{c.value}</div>
                            <div className="overline mt-1">{c.label}</div>
                        </div>
                    );
                })}
            </div>

            <div className="panel p-6 mb-10">
                <div className="overline">Ricavi totali (pagati)</div>
                <div className="font-display text-5xl text-[color:var(--ms-charcoal)] mt-2">€{stats.revenue.toFixed(2)}</div>
            </div>

            <h2 className="font-display text-2xl text-[color:var(--ms-charcoal)] mb-4">Ultimi ordini</h2>
            {recentOrders.length === 0 ? (
                <div className="panel p-10 text-center text-[color:var(--ms-muted)] text-sm">Nessun ordine ancora.</div>
            ) : (
                <div className="panel overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="text-left text-[color:var(--ms-muted)] text-xs uppercase tracking-[0.2em]">
                            <tr>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">N° Ordine</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Email</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Totale</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Stato</th>
                                <th className="px-4 py-3 border-b border-[color:var(--ms-border)]">Data</th>
                            </tr>
                        </thead>
                        <tbody className="text-[color:var(--ms-charcoal)]">
                            {recentOrders.map(o => (
                                <tr key={o.id} className="border-b border-[color:var(--ms-border)]">
                                    <td className="px-4 py-3 font-mono text-xs">{o.id.slice(0, 8)}</td>
                                    <td className="px-4 py-3">{o.email}</td>
                                    <td className="px-4 py-3">€{o.total.toFixed(2)}</td>
                                    <td className="px-4 py-3"><span className={`overline ${o.payment_status === "paid" ? "text-[color:var(--ms-sage-dark)]" : "text-[color:var(--ms-muted)]"}`}>{o.payment_status === "paid" ? "Pagato" : o.payment_status}</span></td>
                                    <td className="px-4 py-3 text-[color:var(--ms-muted)]">{new Date(o.created_at).toLocaleDateString("it-IT")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
